// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ReceivingAddress[data-v-6eb4a58f] {\n  padding: 30px;\n  background-color: white;\n}\n.ReceivingAddress .page[data-v-6eb4a58f] {\n    margin-top: 50px;\n    text-align: right;\n}\n", ""]);
// Exports
module.exports = exports;
